/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ComponentType } from 'react'
import * as React from 'react'
import { getLocalStorageItem, setLocalStorageItem } from './api/localStorage'
import { lastReloadKey } from 'features/common'

export const lazy = (factory: () => Promise<{ default: ComponentType<any> }>) => {
  return React.lazy(() => factory().catch(importErrorHandler))
}

export function importErrorHandler(error: any): { default: ComponentType<any> } {
  const SECOND = 1_000
  const timeStr = getLocalStorageItem(lastReloadKey)
  const time = timeStr ? Number(timeStr) : null
  const now = Date.now()

  // If the last reload time is more than 10 seconds ago, reload the page
  const mustReload = !time || time + 10 * SECOND < now
  if (mustReload) {
    setLocalStorageItem(lastReloadKey, now)
    window.location.reload()
    return { default: () => null }
  }

  throw new Error(error)
}
